export default __webpack_public_path__ + "static/media/pause.cf769c90.png";